export default {"src":"/_next/static/media/sustainable.c29e5cb6.svg","height":15,"width":15};